import { Layout } from 'antd'
import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import ChunkErrorBoundary from './common/ChunkErrorBoundary'
import FourOhFour from './common/FourOhFour'
import PrivacyPolicy from './common/PrivacyPolicy'
import SuspenseFallback from './common/SuspenseFallback'
import './styles/App-Public.css'

// Phase 2 lazy splits: public routes (never loaded during authenticated sessions)
const Login = React.lazy(() => import('./public/Login.js'))
const ForgotPassword = React.lazy(() => import('./public/ForgotPassword'))
const ResetPassword = React.lazy(() => import('./public/ResetPassword'))
const ResetPasswordSuccess = React.lazy(
  () => import('./public/ResetPasswordSuccess'),
)
const Register = React.lazy(() => import('./public/Register'))
const RegistrationPending = React.lazy(
  () => import('./public/RegistrationPending'),
)
const UserExistsNotice = React.lazy(() => import('./public/UserExistsNotice'))

const { Sider, Content } = Layout

const PublicApp = () => (
  <Layout className="public-layout">
    <Sider className="public-sider">
      <img
        className="public-sider__logo"
        src="/BAM-logo-v2.svg"
        alt="BAM! logo"
      />
    </Sider>
    <Content className="public-content__container">
      <ChunkErrorBoundary>
        <React.Suspense fallback={<SuspenseFallback />}>
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/forgot-password" component={ForgotPassword} />
            <Route path="/reset-password/:code" component={ResetPassword} />
            <Route
              path="/reset-password-success"
              component={ResetPasswordSuccess}
            />
            <Route path="/register/:invitation?" component={Register} />
            <Route
              path="/registration-pending"
              component={RegistrationPending}
            />
            <Route path="/user-exists" component={UserExistsNotice} />
            <Route path="/fourohfour" component={FourOhFour} />
            <Route path="/privacy" component={PrivacyPolicy} />
            <Route path="*" render={() => <Redirect to="/login" />} />
          </Switch>
        </React.Suspense>
      </ChunkErrorBoundary>
    </Content>
  </Layout>
)

export default PublicApp
